import { Component, OnInit, Inject, Input } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import {Observable} from "rxjs";
import { Event } from '../../models/event';
import { EventService } from '../../services/event.service';
import { TypeEventService } from '../../services/type-event.service';
import * as esLocale from "date-fns";

@Component({
  selector: 'app-event-dialog',
  templateUrl: './event-dialog.component.html',
  styleUrls: ['./event-dialog.component.css']
})
export class EventDialogComponent implements OnInit {
  @Input() editEvent: any;
  @Input() jobId: any;
  @Input() userId: any;
  @Input() create: boolean;
  msgLoading: boolean;
  eventId: string;
  typeEventList: any;
  event: any;
  errorMessage: string;
  publicating: boolean;
  es: any;
  date: Date;
  time: Date;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: any,
    public eventService: EventService,
    public typeEventService: TypeEventService,
    public dialogRef: MdDialogRef<EventDialogComponent>
  ) { }

  ngOnInit() {
    this.es = {
    firstDayOfWeek: 1,
      dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado" ],
      dayNamesShort: [ "dom","lun","mar","mié","jue","vie","sáb" ],
      monthNames: [ "enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre" ],
      monthNamesShort: [ "ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic" ],
      dateFns: esLocale
    };

    this.publicating = false;
    this.getTypeEventList ();
    if (this.create) {
      this.event = {
        id: undefined,
        dateandtime: new Date(),
        details: '',
        type: undefined,
        jobid: this.jobId,
        userid: this.userId,
        user: this.editEvent.user
      };
    } else {
      this.event = {
        id: this.editEvent.id,
        dateandtime: this.editEvent.start,
        details: this.editEvent.details,
        type: this.editEvent.type,
        jobid: this.jobId,
        userid: this.userId,
        user: this.editEvent.user
      };
    }
    this.date = new Date (this.event.dateandtime);
    this.time = new Date (this.event.dateandtime);
  }

  getTypeEventList () {
    this.typeEventList = [];
    this.typeEventService.getTypeEventList(1, 1000)
    .subscribe(
      data => {
        this.typeEventList = data.eventtype;
      },
      error => {
      }
    );
  }

  onEvent() {
    if (this.create) {
      this.onPostEvent ();
    } else {
      this.onPutEvent ();
    }
  }

  onPostEvent () {
    this.publicating = true;
    const month = this.date.getMonth() + 1;
    const a = this.date.getFullYear() + '-' + month + '-' + this.date.getDate() + ' ' + this.time.getHours() +
    ':' + this.time.getMinutes() + ':00:00';
    this.event.dateandtime = new Date (a);
    this.eventService.postEvent(this.event)
    .subscribe(
      data => {
        this.dialogRef.close();
      },
      error => {
        this.errorMessage = <any>error
        this.publicating = false;
      }
    );
  }

  onPutEvent () {
    this.publicating = true;
    const month = this.date.getMonth() + 1;
    const a = this.date.getFullYear() + '-' + month + '-' + this.date.getDate() + ' ' + this.time.getHours() +
    ':' + this.time.getMinutes() + ':00:00';
    this.event.dateandtime = new Date (a);
    this.eventService.putEvent(this.event)
    .subscribe(
      data => {
        this.dialogRef.close();
      },
      error => {
        this.errorMessage = <any>error
        this.publicating = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/event-dialog/event-dialog.component.ts